import { render, staticRenderFns } from "./invoice-form.vue?vue&type=template&id=957ac01e&scoped=true&"
import script from "./invoice-form.vue?vue&type=script&lang=js&"
export * from "./invoice-form.vue?vue&type=script&lang=js&"
import style0 from "./invoice-form.vue?vue&type=style&index=0&id=957ac01e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "957ac01e",
  null
  
)

export default component.exports